import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const images = [
  { src: "./img/wellness/wellness-uvodni.jpg", alt: "Prosklená odpočívárna, lehátka a venkovní vířivka na kamenné podlaze" },
  { src: "./img/wellness/wellness-virivka-kryta.jpg", alt: "Krytá vířivka až pro 5 osob v dřevěném obložení" },
  { src: "./img/wellness/wellness-sauna-finska.jpg", alt: "Prosklená finská sauna vytápěná saunovými kamny na dřevo" },
  { src: "./img/wellness/wellness-odpocivarna.jpg", alt: "Prosklená odpočívárna a lehátka na kamenné terase" },
  { src: "./img/wellness/wellness-virivka-venkovni.jpg", alt: "Venkovní vířivka a lehátka na kamenné podlaze" },
  { src: "./img/wellness/wellness-venkovni-zahradka.jpg", alt: "Venkovní zahrádka wellness s kameny, bonsajemi a posezením" },
  { src: "./img/wellness/wellness-vyhled-lesy-louky.jpg", alt: "Výhled z wellness do valašských lesů a luk za soumraku" },
  { src: "./img/wellness/wellness-1.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
  { src: "./img/wellness/wellness-2.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
  { src: "./img/wellness/wellness-3.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
  { src: "./img/wellness/wellness-4.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
  { src: "./img/wellness/wellness-5.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
  { src: "./img/wellness/wellness-6.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
  { src: "./img/wellness/wellness-7.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
  { src: "./img/wellness/wellness-8.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
  { src: "./img/wellness/wellness-9.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
  { src: "./img/wellness/wellness-10.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
  { src: "./img/wellness/wellness-11.jpg", alt: "Wellness Hospůdky pod Rablinů – sauna, vířivka a odpočívárna" },
];

const FotogalerieWellness: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Wellness & Spa | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Fotogalerie wellness Hospůdky pod Rablinů – vířivky, finská sauna a odpočívárna."
        />
      </Helmet>

      {/* ================= NAVBAR (IZOLOVANÝ) ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">

        {/* ================= NADPIS ================= */}
        <section className="bg-white py-20 text-center">
          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            WELLNESS & SPA
          </h1>
        </section>

        {/* ================= GALERIE ================= */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              gap-6
            "
          >
            {images.map((img) => (
              <img
                key={img.src}
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="
                  w-full
                  h-64
                  object-cover
                  rounded-xl
                  shadow-md
                  hover:scale-[1.02]
                  transition-transform
                  duration-300
                "
              />
            ))}
          </div>

          <div className="mt-16 text-center">
            <Link to="/wellness">
              <button className="bg-[#60260F] hover:bg-[#965126] text-white w-72 py-4 rounded-xl text-lg font-semibold transition-colors">
                Více o wellness
              </button>
            </Link>
          </div>
        </section>

        {/* ================= FOOTER (ABSOLUTNÍ RESET) ================= */}
        <div className="[all:unset] block">
          <Footer />
        </div>

      </main>
    </>
  );
};

export default FotogalerieWellness;
